import React from "react"
import Slider from "./slider"
import Printing from "./printing"
import Gallery from "./gallery"
import Content from "./content"
import Services from "./services"
import DigitalServices from "./digital-services"
import Production from "./production"
import Portfolio from "../../portfolio/portfolio"
import Service from "../../home/services"
import Clients from "../../home/clients"

const printingpage = () => {
  return (
    <>
      <Slider />
      <Printing />
      <Gallery />
      <Content />
      <Services />
      <DigitalServices />
      <Production />
      <Portfolio />
      <Service />
      <Clients />
    </>
  )
}

export default printingpage
